/*
  DP · Geurquiz — logica (v9).

  Hoort bij sections/dp-quiz.liquid: de opmaak staat daar, de vragen en de
  weging staan hier.

  Overgenomen uit het live thema "quizfix" (snippets/dp-geurquiz.liquid).
  Het verschil met de oudere v8 is dat er geen handmatige productlijst meer is.
  v8 hield twaalf lijsten met ~205 producthandles bij en kende maar vier
  families; die lijst liep achter op de metavelden en brak volledig zodra een
  product werd hernoemd.

  v9 haalt de producten bij Shopify zelf op:
    /collections/<vrouwen|mannen|unisex|alle>
      ?filter.p.m.custom.geurfamilie=<familie>&view=quiz
  Dat is de Search & Discovery-filter, server-side toegepast, met
  templates/collection.quiz.liquid als JSON-uitvoer.

  10 september 2026: het gewicht van vraag 7 ('Welke geur zou je nooit willen
  dragen?') is van 3 naar 1 gebracht. Die vraag woog even zwaar als de
  hoofdvraag maar deelt haar punten uit aan drie families tegelijk, waardoor ze
  in 41% van de antwoordcombinaties de familie overrulede die de bezoeker zelf
  had aangeklikt. Nu is dat 27%.

  ONDERHOUD
  Geen. Wel dit: een product zonder custom.geurfamilie doet niet mee.
*/
(function () {
  'use strict';

  /* De zeven families zoals ze in custom.geurfamilie staan. */
  var ZWAAR = { 'Gourmand': 1, 'Oriëntaals': 1, 'Houtachtig': 1, 'Kruidig': 1 };
  var LICHT = { 'Fris': 1, 'Bloemig': 1, 'Fruitig': 1 };
  var COLLECTIE = { dames: 'vrouwen', heren: 'mannen', unisex: 'unisex', alles: 'alle' };

  var PROFIELEN = {
    'Fris':       { naam: 'Fris & Citrus',         tekst: 'Licht, schoon en energiek. Een geur die de dag opent in plaats van hem over te nemen.' },
    'Bloemig':    { naam: 'Bloemig & Elegant',     tekst: 'Zacht en verfijnd. Aanwezig zonder de aandacht op te eisen.' },
    'Fruitig':    { naam: 'Fruitig & Sprankelend', tekst: 'Sappig en licht zoet. Vrolijk zonder zwaar te worden.' },
    'Gourmand':   { naam: 'Zoet & Gourmand',       tekst: 'Vanille, karamel en warmte. Een geur die opvalt en blijft hangen.' },
    'Houtachtig': { naam: 'Warm & Houtig',         tekst: 'Diep en zelfverzekerd. Op zijn best als het buiten kouder wordt.' },
    'Kruidig':    { naam: 'Kruidig & Aromatisch',  tekst: 'Peper, kardemom en kaneel. Pittig, met karakter.' },
    'Oriëntaals': { naam: 'Oriëntaals & Warm',     tekst: 'Amber, wierook en hars. Rijk en avondlijk, een geur die je opmerkt.' }
  };

  var QUESTIONS = [
    { as: 'groep', q: 'Voor wie zoek je een geur?', a: [
      { t: 'Voor haar', v: 'dames' },
      { t: 'Voor hem', v: 'heren' },
      { t: 'Unisex, voor allebei', v: 'unisex' },
      { t: 'Geen voorkeur, verras me', v: 'alles' }
    ]},
    { as: 'familie', w: 3, hoofd: true, q: 'Wat voor soort geur zoek je?', a: [
      { t: 'Fris en citrusachtig', v: ['Fris'] },
      { t: 'Bloemig en zacht', v: ['Bloemig'] },
      { t: 'Fruitig en sappig', v: ['Fruitig'] },
      { t: 'Zoet en snoepachtig', v: ['Gourmand'] },
      { t: 'Warm en houtig', v: ['Houtachtig'] },
      { t: 'Kruidig en pittig', v: ['Kruidig'] },
      { t: 'Oriëntaals en balsemachtig', v: ['Oriëntaals'] }
    ]},
    { as: 'familie', w: 2, q: 'Wanneer draag je deze geur het liefst?', a: [
      { t: 'Overdag, naar werk of school', v: ['Fris'] },
      { t: 'Een etentje of romantische avond', v: ['Bloemig', 'Oriëntaals'] },
      { t: 'Uitgaan, feest, festival', v: ['Gourmand', 'Fruitig'] },
      { t: 'Koude avonden, als statement', v: ['Houtachtig', 'Kruidig'] }
    ]},
    { as: 'familie', w: 2, q: 'In welk seizoen ga je hem het meest dragen?', a: [
      { t: 'Zomer', v: ['Fris', 'Fruitig'] },
      { t: 'Lente', v: ['Bloemig', 'Fruitig'] },
      { t: 'Herfst', v: ['Houtachtig', 'Kruidig'] },
      { t: 'Winter', v: ['Gourmand', 'Oriëntaals'] }
    ]},
    { as: 'familie', w: 2, q: 'Welke combinatie klinkt het lekkerst?', a: [
      { t: 'Bergamot, citroen en zeebries', v: ['Fris'] },
      { t: 'Roos, pioenroos en jasmijn', v: ['Bloemig'] },
      { t: 'Framboos, perzik en zwarte bes', v: ['Fruitig'] },
      { t: 'Vanille, karamel en tonkaboon', v: ['Gourmand'] },
      { t: 'Ceder, vetiver en sandelhout', v: ['Houtachtig'] },
      { t: 'Peper, kardemom en kaneel', v: ['Kruidig'] },
      { t: 'Oud, wierook en amber', v: ['Oriëntaals'] }
    ]},
    { as: 'familie', w: 1, q: 'Welke omschrijving past het best bij jou?', a: [
      { t: 'Sportief en energiek', v: ['Fris'] },
      { t: 'Elegant en verfijnd', v: ['Bloemig'] },
      { t: 'Speels en opvallend', v: ['Fruitig', 'Gourmand'] },
      { t: 'Zelfverzekerd en mysterieus', v: ['Houtachtig', 'Oriëntaals'] }
    ]},
    { as: 'familie', w: 1, q: 'Welke geur zou je nooit willen dragen?', a: [
      { t: 'Iets zwaars en rokerigs', v: ['Fris', 'Bloemig', 'Fruitig'] },
      { t: 'Iets suikerzoets', v: ['Fris', 'Houtachtig', 'Kruidig'] },
      { t: 'Iets kils en zeepachtigs', v: ['Gourmand', 'Oriëntaals'] },
      { t: 'Iets bloemigs en lichts', v: ['Houtachtig', 'Kruidig', 'Oriëntaals'] }
    ]},
    { as: 'kracht', q: 'Hoeveel ruimte mag de geur innemen?', a: [
      { t: 'Subtiel, alleen merkbaar van dichtbij', v: 'licht' },
      { t: 'Gemiddeld, netjes binnen mijn eigen bubbel', v: 'licht' },
      { t: 'Duidelijk aanwezig in de ruimte', v: 'zwaar' },
      { t: 'Zo sterk mogelijk, mensen mogen ernaar vragen', v: 'zwaar' }
    ]},
    { as: 'duur', q: 'Hoe lang moet de geur blijven zitten?', a: [
      { t: 'Een halve dag is prima', v: 'standaard' },
      { t: 'Zo lang mogelijk, ook na een lange werkdag', v: 'lang' },
      { t: 'Het liefst de sterkste variant die er is', v: 'lang' },
      { t: 'Maakt me niet uit', v: 'egaal' }
    ]}
  ];

  function init(shell) {
    var txt = {
      adding: shell.getAttribute('data-label-adding') || 'Bezig…',
      added: shell.getAttribute('data-label-added') || 'Toegevoegd',
      atc: shell.getAttribute('data-label-atc') || 'In winkelwagen',
      view: shell.getAttribute('data-label-view') || 'Bekijk geur',
      best: shell.getAttribute('data-label-best') || 'Beste match'
    };
    var fallbackCollectie = shell.getAttribute('data-feed-collection') || 'alle';
    var allowAtc = shell.getAttribute('data-atc') === 'true';

    var el = {
      bar: shell.querySelector('[data-quiz-bar]'),
      step: shell.querySelector('[data-quiz-step]'),
      stage: shell.querySelector('[data-quiz-stage]'),
      question: shell.querySelector('[data-quiz-question]'),
      options: shell.querySelector('[data-quiz-options]'),
      back: shell.querySelector('[data-quiz-back]'),
      result: shell.querySelector('[data-quiz-result]'),
      profile: shell.querySelector('[data-quiz-profile]'),
      profileText: shell.querySelector('[data-quiz-profile-text]'),
      cards: shell.querySelector('[data-quiz-cards]'),
      note: shell.querySelector('[data-quiz-note]'),
      more: shell.querySelector('[data-quiz-more]'),
      restart: shell.querySelector('[data-quiz-restart]')
    };
    if (!el.question || !el.options) return;

    var step = 0, answers = [], cache = {}, shown = null;

    function feedUrl(collectie, familie) {
      var url = '/collections/' + collectie + '?view=quiz';
      if (familie) url += '&filter.p.m.custom.geurfamilie=' + encodeURIComponent(familie);
      return url;
    }

    /* Geen Accept-header meesturen: op 'text/plain' antwoordt Shopify met 404. */
    function haalFeed(collectie, familie) {
      var url = feedUrl(collectie, familie);
      if (cache[url]) return Promise.resolve(cache[url]);
      return fetch(url)
        .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.text(); })
        .then(function (t) {
          var lijst = (JSON.parse(t).producten) || [];
          cache[url] = lijst;
          return lijst;
        });
    }

    /* De hoofdvraag is het sterkste signaal en wint bij gelijkspel. Daarom is
       het meestal ook de familie die het resultaat wordt: die alvast ophalen
       terwijl iemand de rest beantwoordt, scheelt het wachtmoment op precies
       het punt waar de bezoeker het dichtst bij een aankoop zit. Zit hij er
       toch naast, dan kost het niets: de echte fetch gebeurt gewoon daarna. */
    function warmUp(groep, familie) {
      var collectie = COLLECTIE[groep] || fallbackCollectie;
      haalFeed(collectie, familie).catch(function () {});
    }

    function money(n) {
      if (typeof n !== 'number' || isNaN(n)) return '';
      return '€ ' + n.toFixed(2).replace('.', ',');
    }

    function render() {
      var q = QUESTIONS[step];
      el.question.textContent = q.q;
      el.options.textContent = '';

      q.a.forEach(function (opt, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dp-quiz__opt';
        var key = document.createElement('span');
        key.className = 'dp-quiz__key';
        key.textContent = String.fromCharCode(65 + i);
        b.appendChild(key);
        b.appendChild(document.createTextNode(opt.t));
        b.addEventListener('click', function () { choose(opt.v); });
        el.options.appendChild(b);
      });

      el.step.textContent = 'Vraag ' + (step + 1) + ' van ' + QUESTIONS.length;
      el.bar.style.width = ((step + 1) / QUESTIONS.length * 100) + '%';
      el.back.hidden = step === 0;
    }

    function choose(v) {
      answers[step] = v;
      if (QUESTIONS[step].hoofd && Array.isArray(v)) warmUp(answers[0], v[0]);
      if (step < QUESTIONS.length - 1) {
        step++;
        render();
      } else {
        finish();
      }
    }

    function shuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
      }
      return arr;
    }

    function bepaalUitslag() {
      var groep = 'alles', kracht = 'licht', duur = 'egaal';
      var score = {}, hoofdkeuze = null;

      QUESTIONS.forEach(function (q, i) {
        var v = answers[i];
        if (v === undefined) return;
        if (q.as === 'groep') groep = v;
        else if (q.as === 'kracht') kracht = v;
        else if (q.as === 'duur') duur = v;
        else {
          v.forEach(function (f) { score[f] = (score[f] || 0) + q.w; });
          if (q.hoofd) hoofdkeuze = v[0];
        }
      });

      var gesorteerd = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; });
      var familie = gesorteerd[0] || hoofdkeuze || 'Fris';
      /* Gelijkspel aan kop? Dan telt de vraag waarin je het zelf hebt gezegd. */
      if (hoofdkeuze && score[hoofdkeuze] === score[familie]) familie = hoofdkeuze;
      var tweede = gesorteerd.length > 1 && gesorteerd[1] !== familie ? gesorteerd[1] : null;

      return { groep: groep, familie: familie, tweede: tweede, kracht: kracht, duur: duur };
    }

    function weeg(lijst, uitslag) {
      return shuffle(lijst.slice()).map(function (p) {
        var fams = p.f || [];
        var zw = 0;
        fams.forEach(function (f) {
          if (ZWAAR[f]) zw++;
          else if (LICHT[f]) zw--;
        });
        var s = (uitslag.kracht === 'zwaar') ? zw : -zw;
        if (uitslag.duur === 'lang' && p.p >= 30) s += 2;
        else if (uitslag.duur === 'standaard' && p.p < 30) s += 1;
        /* Past hij ook bij de tweede familie uit je profiel? Dan is het een
           vollediger match dan een product dat alleen de winnaar raakt. */
        if (uitslag.tweede && fams.indexOf(uitslag.tweede) !== -1) s += 2;
        return { product: p, score: s };
      }).sort(function (a, b) { return b.score - a.score; });
    }

    function addToCart(variantId, button) {
      button.disabled = true;
      button.textContent = txt.adding;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          button.textContent = txt.added;
          /* Hetzelfde event dat het thema zelf gebruikt na een toevoeging:
             de winkelwagenteller leest de nieuwe aantallen en de lade haalt
             haar eigen inhoud opnieuw op. */
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'dp-quiz',
              data: { itemCount: cart.item_count, source: 'dp-quiz' }
            }
          }));
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = txt.atc;
        });
    }

    function card(item, isTop, label) {
      var p = item.product;
      var wrap = document.createElement('article');
      wrap.className = 'dp-quiz__card' + (isTop ? ' dp-quiz__card--top' : '');

      var thumb = document.createElement('span');
      thumb.className = 'dp-quiz__thumb';
      if (p.b) {
        var img = document.createElement('img');
        img.src = p.b.indexOf('//') === 0 ? 'https:' + p.b : p.b;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 320;
        img.height = 320;
        thumb.appendChild(img);
      }
      wrap.appendChild(thumb);

      var body = document.createElement('div');
      body.className = 'dp-quiz__card-body';

      if (label) {
        var badge = document.createElement('span');
        badge.className = 'dp-quiz__card-badge';
        badge.textContent = label;
        body.appendChild(badge);
      }

      var name = document.createElement('h4');
      name.className = 'dp-quiz__card-name';
      var link = document.createElement('a');
      link.href = '/products/' + p.h;
      link.textContent = p.t;
      name.appendChild(link);
      body.appendChild(name);

      var price = document.createElement('p');
      price.className = 'dp-quiz__card-price';
      price.textContent = money(p.p);
      body.appendChild(price);

      var actions = document.createElement('div');
      actions.className = 'dp-quiz__card-actions';

      if (allowAtc && p.v && p.a !== false) {
        var atc = document.createElement('button');
        atc.type = 'button';
        atc.className = 'dp-quiz__atc';
        atc.textContent = txt.atc;
        atc.addEventListener('click', function () { addToCart(p.v, atc); });
        actions.appendChild(atc);
      }

      var view = document.createElement('a');
      view.className = 'dp-quiz__view';
      view.href = '/products/' + p.h;
      view.textContent = txt.view;
      actions.appendChild(view);

      body.appendChild(actions);
      wrap.appendChild(body);
      return wrap;
    }

    function show(items, from) {
      el.cards.textContent = '';
      var slice = items.slice(from, from + 3);
      if (!slice.length) { el.more.hidden = true; return; }

      slice.forEach(function (item, i) {
        var isTop = (i === 0 && from === 0);
        el.cards.appendChild(card(item, isTop, isTop ? txt.best : null));
      });

      el.more.hidden = items.length <= from + 3;
    }

    function finish() {
      var uitslag = bepaalUitslag();
      var prof = PROFIELEN[uitslag.familie] || PROFIELEN['Fris'];

      el.profile.textContent = prof.naam;
      el.profileText.textContent = prof.tekst;
      el.stage.hidden = true;
      el.result.hidden = false;
      el.bar.style.width = '100%';
      el.step.textContent = 'Klaar';
      el.note.hidden = true;
      el.more.hidden = true;
      el.cards.textContent = '';

      var collectie = COLLECTIE[uitslag.groep] || fallbackCollectie;
      var link = '/collections/' + collectie +
        '?filter.p.m.custom.geurfamilie=' + encodeURIComponent(uitslag.familie);

      haalFeed(collectie, uitslag.familie).then(function (lijst) {
        /* Niets in deze doelgroep? Dan de familie over de hele collectie. */
        if (lijst.length === 0 && collectie !== fallbackCollectie) {
          return haalFeed(fallbackCollectie, uitslag.familie).then(function (breder) {
            link = '/collections/' + fallbackCollectie +
              '?filter.p.m.custom.geurfamilie=' + encodeURIComponent(uitslag.familie);
            return breder;
          });
        }
        return lijst;
      }).then(function (lijst) {
        if (lijst.length === 0) throw new Error('geen producten');
        var items = weeg(lijst, uitslag);
        shown = { items: items, from: 0 };
        show(items, 0);
        el.note.innerHTML = 'Alle ' + lijst.length + ' geuren in dit profiel? ' +
          '<a href="' + link + '">Bekijk ze allemaal</a>';
        el.note.hidden = false;
      }).catch(function () {
        el.note.innerHTML = 'De geuren konden even niet geladen worden. ' +
          '<a href="/collections/' + fallbackCollectie + '">Bekijk de collectie</a>';
        el.note.hidden = false;
      });
    }

    el.back.addEventListener('click', function () {
      if (step > 0) { step--; render(); }
    });

    el.more.addEventListener('click', function () {
      if (!shown) return;
      shown.from += 3;
      if (shown.from >= shown.items.length) shown.from = 0;
      show(shown.items, shown.from);
    });

    el.restart.addEventListener('click', function () {
      step = 0;
      answers = [];
      shown = null;
      el.result.hidden = true;
      el.stage.hidden = false;
      render();
    });

    render();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-dp-quiz]').forEach(function (shell) {
      if (shell.hasAttribute('data-dp-quiz-ready')) return;
      shell.setAttribute('data-dp-quiz-ready', '');
      init(shell);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();